module.exports = __webpack_public_path__ + "img/success.e0f23781.png";